<template>
  <div>
        <div style="display: flex; flex-direction: row; flex-wrap: wrap; margin-top: 10px; width: 100%;">
            <div style="margin-top: 10px; text-align: left;">
            <span type="label">Old Weight</span>
            <br>
            <el-input @focus="$event.target.select()"
                size="small"
                type="number"
                v-model="$store.state.customerMaster.props.old_weight"
                style="width: 150px;">
                <template slot="append">Kg</template>
            </el-input>
        </div>
        <div style="margin-top: 10px;margin-left: 10px; text-align: left;">
            <span type="label">New Weight</span>
            <br>
            <el-input @focus="$event.target.select()"
                size="small"
                type="number"
                v-model="$store.state.customerMaster.props.new_weight"
                style="width: 150px;">
                <template slot="append">Kg</template>
            </el-input>
        </div>
        <div style="margin-top: 10px;margin-left: 10px; text-align: left;">
            <span type="label">Height</span>
            <br>
            <el-input @focus="$event.target.select()"
                size="small"
                type="number"
                v-model="$store.state.customerMaster.props.height"
                style="width: 150px;">
                <template slot="append">Feets</template>
            </el-input>
        </div>
        <div style="margin-top: 10px;margin-left: 10px;text-align: left;">
            <span type="label">Measured By</span>
            <br>
            <el-select 
                size="small"
                v-model="$store.state.customerMaster.props.measurement_master_measured_by_staff_id" 
                filterable style="width: 250px; text-align: left;">
                <el-option
                    v-for="(data, index) in $store.getters.getEmployeeMasterList.filter(t => t.active && t.can_take_measurement)"
                    :key="index"
                    :label="data.staff_name"
                    :value="data.id">
                    <span style="float: left" v-html="data.staff_name"></span>
                </el-option>
            </el-select>
        </div>

        <div 
            v-for="(data, index) in getItemList" 
            :key="index"
            style="margin-top: 10px;margin-left: 10px;text-align: left;">
            <span type="label">{{data.category_name}} Size</span>
            <br>
            <el-select 
                style="width: 100px;"
                size="small"
                v-model="data.size_id" 
                filterable>
                <el-option
                    v-for="(data1, index1) in $store.getters.getTailoringSizeList.filter(t => (t.tailoring_category_id === data.category_id || t.tailoring_category_id === 0))"
                    :key="index1+'_SIZE'"
                    :label="data1.size_name"
                    :value="data1.id">
                    <span style="float: left" v-html="data1.size_name"></span>
                </el-option>
            </el-select>
        </div>

        
      </div>
      <div style="border-bottom: 1px solid #e2e2e2;">
          <span v-html="'&nbsp;'"></span>
      </div>
      <el-table
        :data="getMasterMeasurementSheet"
        style="width: 100%">
        <el-table-column 
        prop="measurement_name"
        label="Measurement Name">
        </el-table-column>
        <el-table-column 
        prop="measurement_value"
        label="Value">
            <template slot-scope="scope">
                <el-select 
                    style="width: 100%;"
                    v-if="scope.row.measurement_value_fixed"
                    size="small"
                    @change="scope.row.measurement_instruction_image = data.measurement_instruction_image"
                    v-model="scope.row.measurement_value" 
                    filterable>
                    <el-option
                        v-for="(data, index) in scope.row.measurement_drop_down_list"
                        :key="index"
                        v-if="data.measurement_value !== null && data.measurement_value.trim().length > 0"
                        :label="data.measurement_value"
                        :value="data.measurement_value">
                        <span style="float: left" v-html="data.measurement_value"></span>
                    </el-option>
                </el-select>
                <el-input @focus="$event.target.select()"
                    v-else
                    size="small"
                    v-model="scope.row.measurement_value">
                </el-input>
            </template>
        </el-table-column>
        
        <el-table-column 
        label="Instructional Image" align="center">
            <template slot-scope="scope">
                <UploadFile 
                    :image_path="scope.row.measurement_instruction_image"
                    :image_width="25"
                    :hide_upload="true"
                />  
            </template> 
        </el-table-column>
       </el-table>

  </div>
</template>

<script>
export default {
    data() {
        return {
            item_list: []
        }
    },
    computed: {
        getItemList() {

            this.$store.state.customerMaster.props.measurement_master_size_id = []
            this.$store.getters.getItemCategoryList.forEach(element => {

                let categoryIndex = this.$store.getters.getCustomerMasterDataProps.temp_measurement_profile_list.findIndex(t => t.tailoring_category_id === element.id)

                let sizeId = 0
                if(categoryIndex>=0) {

                    let size = 0
                    if(this.$store.state.customerMaster.props.temp_measurement_profile_list[categoryIndex].profile_list[0] !== undefined) {
                        size = this.$store.state.customerMaster.props.temp_measurement_profile_list[categoryIndex].profile_list[0].size_id
                    }
                    sizeId = size !== undefined ? size : 0
                }
                this.$store.state.customerMaster.props.measurement_master_size_id.push({
                    category_id: element.id,
                    category_name: element.category_name,
                    size_id: sizeId
                })

            })
            return this.$store.state.customerMaster.props.measurement_master_size_id
        },
        getMasterMeasurementSheet() {

            let measurement_master_sheet = this.$store.state.customerMaster.props.measurement_master_sheet
            let list = []

            this.$store.getters.getMeasurementMasterList.forEach(element => {
                let measurement_value = ""
                let msmtIndex = this.getAllMeasurementFieldList.findIndex(t => t.master_measurement_id === element.id)
                if(msmtIndex>=0) {
                    measurement_value = this.getAllMeasurementFieldList[msmtIndex].measurement_value
                }
                list.push({
                    id: element.id,
                    measurement_name: element.measurement_name,
                    measurement_value_fixed: element.measurement_value_fixed,
                    measurement_drop_down_list: element.measurement_drop_down_list,
                    measurement_value: measurement_value,
                    measurement_instruction_image: element.measurement_instruction_image
                })

            })
            return this.$store.state.customerMaster.props.measurement_master_sheet 
                        = measurement_master_sheet.length>0 ? measurement_master_sheet : list
        },
        getCustomerMeasurementProfileList() {
            return this.$store.getters.getCustomerMasterDataProps.measurement_profile_list
        },
        getAllMeasurementFieldList() {
            let returnList = []

            this.getCustomerMeasurementProfileList.forEach(element => {
                element.profile_list[0].measurement_field_list.forEach(field => {
                    returnList.push(field)
                })
            })

            return returnList
        }
    },
    methods: {
        setMasterMeasurementSheet() {
            let list = []

            this.$store.getters.getMeasurementMasterList.forEach(element => {
                let measurement_value = ""
                let msmtIndex = this.getAllMeasurementFieldList.findIndex(t => t.master_measurement_id === element.id)
                if(msmtIndex>=0) {
                    measurement_value = this.getAllMeasurementFieldList[msmtIndex].measurement_value
                }
                list.push({
                    id: element.id,
                    measurement_name: element.measurement_name,
                    measurement_value_fixed: element.measurement_value_fixed,
                    measurement_drop_down_list: element.measurement_drop_down_list,
                    measurement_value: measurement_value,
                    measurement_instruction_image: element.measurement_instruction_image
                })

            })
            this.$store.state.customerMaster.props.measurement_master_sheet = list
        }
    },
    mounted() {
        setTimeout(() => {
            this.setMasterMeasurementSheet()    
        }, 400);
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/CustomerMaster/Form/MasterMeasurementSheet.vue